import React, {FC, useState} from 'react'
import i18n from 'live/services/i18n'
import FormGroup from 'live/components/forms/ui/form-group'

interface Props {
    value: string | undefined,
    onChange: (event: any) => void,
    onBlur?: (event: any) => void,
    errors?: Record<string, unknown>[]
}

export const ElementLabelInput: FC<Props> = ({ value, onChange, onBlur, errors }) => {
    return (
        <FormGroup
            type="text"
            label="Label"
            value={value}
            validationState={errors.find(e => e.props.label === value) ? 'error' : 'success'}
            onChange={onChange}
            onBlur={onBlur}
            help={errors.find(e => e.props.label === value) ? i18n('Cannot have duplicated labels.'): undefined}
        />
    )
}